import { rateUnits } from '_legacy/modules/columns/rate/models/RateUnits';
import { TankersGroupType } from './TankersGroupTypes';

export interface RateUnitRanges {
    rateUnit: {};
    from?: number;
    to?: number;
}

export const lpgRateUnitRanges: RateUnitRanges[] = [
    { rateUnit: rateUnits[1], to: 999 },
    { rateUnit: rateUnits[3], from: 1000, to: 99999 },
    { rateUnit: rateUnits[9], from: 100000 },
];

export const defaultRateUnitRanges: RateUnitRanges[] = [
    { rateUnit: rateUnits[1], to: 999 },
    { rateUnit: rateUnits[3], from: 1000 },
];

export const tankersPeriodCoaRateUnitRanges: RateUnitRanges[] = [
    { rateUnit: rateUnits[7], to: 999 }, // WS
    { rateUnit: rateUnits[0], from: 1000 }, // LS
];

export const tankersPeriodNonCoaRateUnitRanges: RateUnitRanges[] = [
    { rateUnit: rateUnits[3] }, // PD
];

export const tankersSpotSttcRateUnitRanges: RateUnitRanges[] = [
    { rateUnit: rateUnits[3] }, // PD
];

export const tankersSpotNonSttcRateUnitRanges: RateUnitRanges[] = [
    { rateUnit: rateUnits[7], to: 999 }, // WS
    { rateUnit: rateUnits[0], from: 1000 }, // LS
];

export const resolveRateUnit = (value: number, ranges: RateUnitRanges[]) => {
    return ranges?.find((range) => {
        const from = range.from ?? Number.MIN_SAFE_INTEGER;
        const to = range.to ?? Number.MAX_SAFE_INTEGER;
        return value >= from && value <= to;
    })?.rateUnit;
};

const isSttc = (type?: string) => (type ?? '').toUpperCase() === 'STTC';
const isCoa = (type?: string) => (type ?? '').toUpperCase() === 'COA';

export const resolveRateUnitForTankers = (
    value: number,
    fixtureType: string,
    tankersGroupType?: TankersGroupType
): any => {
    if (tankersGroupType === TankersGroupType.Period) {
        return isCoa(fixtureType)
            ? resolveRateUnit(value, tankersPeriodCoaRateUnitRanges)
            : resolveRateUnit(value, tankersPeriodNonCoaRateUnitRanges);
    }

    if (tankersGroupType === TankersGroupType.Spot) {
        if (
            typeof fixtureType === 'string' &&
            fixtureType.trim().toLowerCase() === 'o'
        ) {
            return rateUnits[5];
        }

        return isSttc(fixtureType)
            ? resolveRateUnit(value, tankersSpotSttcRateUnitRanges)
            : resolveRateUnit(value, tankersSpotNonSttcRateUnitRanges);
    }

    return resolveRateUnit(value, defaultRateUnitRanges);
};
